import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { setValueByPath } from '@blaze-shared/workflow-domain';

import { type PropsMigration } from '../../../../services/compat/migrations/layout-migration.models';

export const navMenuV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Nav Menu element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'navMenu'>): void => {
    const { style } = props;

    if (style?.default?.text && !style?.default?.iconColor) {
      const currentColor = style.default.text.color1;
      setValueByPath(props.style, 'default.iconColor.color1', currentColor);
    }
    if (style?.hover?.text && !style?.hover?.iconColor) {
      const currentColor = style.hover.text.color1;
      setValueByPath(props.style, 'hover.iconColor.color1', currentColor);
    }
    if (style?.active?.text && !style?.active?.iconColor) {
      const currentColor = style.active.text.color1;
      setValueByPath(props.style, 'active.iconColor.color1', currentColor);
    }

    if (style?.submenu?.default?.text && !style?.submenu?.default?.iconColor) {
      const currentColor = style.submenu.default.text.color1;
      setValueByPath(props.style, 'submenu.default.iconColor.color1', currentColor);
    }
    if (style?.submenu?.hover?.text && !style?.submenu?.hover?.iconColor) {
      const currentColor = style.submenu.hover.text.color1;
      setValueByPath(props.style, 'submenu.hover.iconColor.color1', currentColor);
    }
    if (style?.submenu?.active?.text && !style?.submenu?.active?.iconColor) {
      const currentColor = style.submenu.active.text.color1;
      setValueByPath(props.style, 'submenu.active.iconColor.color1', currentColor);
    }

    if (style?.sections?.label?.text && !style?.sections?.label?.iconColor) {
      const currentColor = style.sections.label.text.color1;
      setValueByPath(props.style, 'sections.label.iconColor.color1', currentColor);
    }
  },
};
